import {ISnackbarData} from '../interfaces/snackbar-data.interface';

export class AddMessageToSnackbarQueueAction {
  static readonly type = '[UI] Add message to snackbar';

  // these are parameters to pass to the action when dispatching it also known as metadata // they work just like normal parameters in normal parameters
  constructor(public snackbarMessage: ISnackbarData) {
  }
}
